export default {
    CREATE_CREDITMEMO_PREPARE_TOTALS: '[CREDITMEMO] CREATE_CREDITMEMO_PREPARE_TOTALS',
    SALES_ORDER_CREDITEMEMO_INIT_TOTAL_COLLECTORS: '[CREDITMEMO] SALES_ORDER_CREDITEMEMO_INIT_TOTAL_COLLECTORS',
    SET_CREDITMEMO: '[CREDITMEMO] SET_CREDITMEMO',
    RESET_CREDITMEMO: '[CREDITMEMO] RESET_CREDITMEMO',
    CREATE_CREDITMEMO: '[CREDITMEMO] CREATE_CREDITMEMO',
    CREATE_CREDITMEMO_AFTER: '[CREDITMEMO] CREATE_CREDITMEMO_AFTER',
    SEND_EMAIL_CREDITMEMO: '[CREDITMEMO] SEND_EMAIL_CREDITMEMO',
    CREDITMEMO_CREATE_CUSTOMER: '[CREDITMEMO] CREDITMEMO_CREATE_CUSTOMER',
    CREDITMEMO_CREATE_CUSTOMER_RESULT: '[CREDITMEMO] CREDITMEMO_CREATE_CUSTOMER_RESULT',
    CREDITMEMO_PROCESS_PAYMENT: '[CREDITMEMO] TAKE_PAYMENT_PROCESS_PAYMENT',
    CREDITMEMO_PROCESS_SINGLE_PAYMENT_RESULT: '[CREDITMEMO] CREDITMEMO_PROCESS_SINGLE_PAYMENT_RESULT',
    CREDITMEMO_PROCESS_SINGLE_PAYMENT_ERROR: '[CREDITMEMO] CREDITMEMO_PROCESS_SINGLE_PAYMENT_ERROR',
    REFUND_OPERATION_REFUND_AFTER: '[CREDITMEMO] REFUND_OPERATION_REFUND_AFTER',
    CREDITMEMO_CREATE_ACTION_LOG_BEFORE: '[CREDITMEMO] CREDITMEMO_CREATE_ACTION_LOG_BEFORE',
}



// WEBPACK FOOTER //
// ./src/view/constant/order/CreditmemoConstant.js